import { Locale } from "src/lib/Intl";
import { omit } from "lodash-es";

const localeCountryMap: { [locale in Locale]: string } = {
  en: "European Union",
  de: "Germany",
  nl: "Netherlands",
  fr: "France",
  "en-gb": "United Kingdom",
  "en-us": "United States",
  "de-at": "Austria",
  "nl-be": "Belgium",
  "en-dk": "Denmark",
  "en-se": "Sweden",
  "pl-pl": "Poland",
  "es-es": "Spain",
  "it-it": "Italy",
};

const countries = {
  AT: "Austria",
  BE: "Belgium",
  CA: "Canada",
  HR: "Croatia",
  CZ: "Czech Republic",
  DK: "Denmark",
  EU: "European Union",
  FR: "France",
  DE: "Germany",
  HU: "Hungary",
  IT: "Italy",
  LU: "Luxembourg",
  NL: "Netherlands",
  PL: "Poland",
  PT: "Portugal",
  SK: "Slovakia",
  SI: "Slovenia",
  ES: "Spain",
  SE: "Sweden",
  CH: "Switzerland",
  GB: "United Kingdom",
  US: "United States",
};

const usStates = {
  AL: "Alabama",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  DC: "District Of Columbia",
  FL: "Florida",
  GA: "Georgia",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};

const usStateOptions = Object.entries(usStates).map(
  ([stateCode, stateName]) => {
    return {
      key: stateCode,
      text: `${stateName} - ${stateCode}`,
      value: stateCode,
    };
  }
);

const countryOptions = Object.entries(omit(countries, ["EU"])).map(
  ([countryCode, countryName]) => {
    return {
      key: countryCode,
      text: countryName,
      value: countryCode,
    };
  }
);

const checkoutCOMCountryOptions = Object.entries(
  omit(countries, ["CA", "CH", "EU", "GB", "US"])
).map(([countryCode, countryName]) => {
  return {
    key: countryCode,
    text: countryName,
    value: countryCode,
  };
});

export {
  localeCountryMap,
  countries,
  usStates,
  usStateOptions,
  countryOptions,
  checkoutCOMCountryOptions,
};
